<template>
  <Dialog 
    v-model:visible="internalVisible"
    modal
    :header="title"
    class="briefing-dialog"
    :style="{ width: '70vw', maxWidth: '900px' }"
    @hide="close"
  >
    <div class="briefing-content">
      <SummerNoteDisplay :content="content" />
    </div>
  </Dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import SummerNoteDisplay from '@/components/summerNote/SummerNoteDisplay.vue'

const props = defineProps({
  modelValue: Boolean,
  title: {
    type: String,
    default: "Briefing do Projeto"
  },
  content: {
    type: String,
    default: ""
  }
})

const emit = defineEmits(["update:modelValue"])

// Controle interno do v-model
const internalVisible = ref(props.modelValue)

// Quando o pai mudar, sincronizamos
watch(
  () => props.modelValue,
  (newVal) => {
    internalVisible.value = newVal
  }
)

// Quando o Dialog mudar, avisamos o pai
watch(internalVisible, (val) => {
  emit("update:modelValue", val)
})

const close = () => {
  internalVisible.value = false
}
</script>

<style scoped>
.briefing-dialog .briefing-content {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}

.briefing-content p {
  margin-bottom: 10px;
}
</style>
